// =====================================================================
// Bundle Builder - versione KIT (Discount Function) - DATI v2
// ---------------------------------------------------------------------
// v2 (lug 2026): window.bundleData arriva gia' RAGGRUPPATO PER COLORE dal
// Liquid: una voce per colore con le taglie annidate in `variants`
// [{id, size|null, price, available}]. Qui non esiste piu' processProducts
// ne' alcuna ricerca della chiave colore nelle options: il vecchio schema
// (una voce per variante + chiavi opzione localizzate) si rompeva quando le
// traduzioni dei nomi opzione erano parziali (in /it spariva mezzo catalogo).
// L'identita' per il carrello resta il variant id numerico.
//
// Checkout: /cart/add.js -> /cart. La Discount Function "offer-kit3"
// riconosce jersey+bib+calza nel carrello e applica il -15% da sola.
// Backup: assets/bundle-builder-kit.js (copia identica a questo file).
// =====================================================================

document.addEventListener('DOMContentLoaded', function () {
  const previewBox = document.getElementById('bundle-preview');
  const addButton = document.getElementById('add-bundle-to-cart');
  const genderButtons = document.querySelectorAll('[data-gender]');

  if (!addButton || !previewBox) return;

  let activeBlockId = null;
  let selections = {};
  let requiredSelectionsCount = 0;

  function getCurrencySymbol(currency) {
    const symbols = {
      EUR: '€', USD: '$', GBP: '£', CNY: '¥', JPY: '¥', AUD: 'A$',
      CAD: 'C$', CHF: 'CHF', SEK: 'kr', NOK: 'kr', DKK: 'kr', PLN: 'zł',
    };
    return symbols[currency] || currency + ' ';
  }

  genderButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      genderButtons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');

      const genderId = btn.dataset.gender;
      activeBlockId = genderId;

      document.querySelectorAll('.products-grid.scrollable-grid').forEach((grid) => {
        grid.style.display = 'none';
      });

      const tabsLeftContainer = document.querySelector('.tabs-left');
      tabsLeftContainer.innerHTML = '';

      const collections = window.bundleMapping[genderId];
      if (collections) {
        Object.entries(collections).forEach(([collectionKey, label]) => {
          if (label) {
            const tabButton = document.createElement('button');
            tabButton.classList.add('tab');
            tabButton.dataset.collection = `${genderId}-${collectionKey}`;
            tabButton.dataset.gender = genderId;
            tabButton.textContent = label;
            tabsLeftContainer.appendChild(tabButton);
          }
        });
      }

      bindCollectionTabs();
      renderProducts();
      rebindSliderTracks();

      const allTabs = tabsLeftContainer.querySelectorAll('.tab');
      if (allTabs.length > 0) setTimeout(() => allTabs[0].click(), 0);

      document.querySelectorAll('.bundle-step').forEach((s) => s.classList.remove('active'));
      const relatedStep = document.querySelector(`.bundle-step[data-step="${genderId}"]`);
      if (relatedStep) {
        relatedStep.classList.add('active');
        relatedStep.classList.add('fading-in');
        setTimeout(() => relatedStep.classList.remove('fading-in'), 300);
      }
    });
  });

  function bindCollectionTabs() {
    document.querySelectorAll('.tab').forEach((tab) => {
      tab.replaceWith(tab.cloneNode(true));
    });

    document.querySelectorAll('.tab').forEach((tab) => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.tab').forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        const relatedStep = document.querySelector(`.bundle-step[data-step="${tab.dataset.gender}"]`);
        if (relatedStep) {
          const wrapper = relatedStep.querySelector('.products-slider-wrapper');
          const sliderThumb = relatedStep.querySelector('.slider-thumb');
          if (wrapper) {
            requestAnimationFrame(() => {
              wrapper.scrollLeft = 0;
              if (sliderThumb) sliderThumb.style.transform = 'translateX(0px)';
            });
          }
        }

        document.querySelectorAll('.products-grid.scrollable-grid').forEach((grid) => {
          grid.style.display = 'none';
        });

        const activeGrid = document.getElementById(tab.dataset.collection);
        if (activeGrid) activeGrid.style.display = 'grid';

        const genderId = tab.dataset.gender;
        if (genderId) {
          document.querySelectorAll('.gender-btn').forEach((b) => b.classList.remove('active'));
          const activeGenderButton = document.querySelector(`.gender-btn[data-gender="${genderId}"]`);
          if (activeGenderButton) activeGenderButton.classList.add('active');
        }
      });
    });
  }

  function renderProducts() {
    const activeGenderButton = document.querySelector('[data-gender].active');
    activeBlockId = activeGenderButton ? activeGenderButton.dataset.gender : null;
    if (!activeBlockId) return;

    const collections = window.bundleData[activeBlockId];
    if (!collections) return;

    const validCollections = Object.entries(collections).filter(([key, value]) => (
      key.startsWith('collection_') &&
      Array.isArray(value) &&
      value.length > 0 &&
      value.some((item) => item !== null && item !== undefined)
    ));

    selections = {};
    requiredSelectionsCount = 0;

    validCollections.forEach(([collectionKey, groups]) => {
      const containerId = `${activeBlockId}-${collectionKey}`;
      const container = document.getElementById(containerId);
      if (!container) return;

      container.innerHTML = '';
      renderGrid(groups, containerId, collectionKey);
      container.style.display = 'grid';
      selections[collectionKey] = null;
      requiredSelectionsCount++;
    });
  }

  function rebindSliderTracks() {
    document.querySelectorAll('.bundle-step').forEach((step) => {
      const wrapper = step.querySelector('.products-slider-wrapper');
      const sliderTrack = step.querySelector('.slider-track');
      const sliderThumb = step.querySelector('.slider-thumb');
      if (!wrapper || !sliderTrack || !sliderThumb) return;

      if (wrapper.dataset.sliderBound === '1') return;
      wrapper.dataset.sliderBound = '1';

      let isDown = false;
      let startX;
      let scrollLeft;

      const updateThumbWidth = () => {
        const scrollableWidth = wrapper.scrollWidth;
        const visibleWidth = wrapper.clientWidth;
        sliderThumb.style.width = scrollableWidth <= visibleWidth
          ? '100%'
          : `${(visibleWidth / scrollableWidth) * 100}%`;
      };

      wrapper.addEventListener('mousedown', (e) => {
        isDown = true;
        wrapper.classList.add('dragging');
        startX = e.pageX - wrapper.offsetLeft;
        scrollLeft = wrapper.scrollLeft;
      });
      wrapper.addEventListener('mouseleave', () => {
        isDown = false;
        wrapper.classList.remove('dragging');
      });
      wrapper.addEventListener('mouseup', () => {
        isDown = false;
        wrapper.classList.remove('dragging');
      });
      wrapper.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - wrapper.offsetLeft;
        wrapper.scrollLeft = scrollLeft - (x - startX) * 1.4;
      });

      wrapper.addEventListener('scroll', () => {
        const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
        const maxThumbMove = sliderTrack.offsetWidth - sliderThumb.offsetWidth;
        sliderThumb.style.transform = maxScroll > 0
          ? `translateX(${(wrapper.scrollLeft / maxScroll) * maxThumbMove}px)`
          : 'translateX(0px)';
      });

      new MutationObserver(() => {
        updateThumbWidth();
        wrapper.dispatchEvent(new Event('scroll'));
      }).observe(wrapper, { childList: true, subtree: true });

      updateThumbWidth();
    });
  }

  function updatePreview() {
    const count = Object.values(selections).filter((v) => v !== null).length;

    const bundleText = document.querySelector('.bundle-summary h3');
    if (bundleText) {
      const requiredCount = window.bundleRequiredCount || requiredSelectionsCount;
      const bundleOfText = (window.bundleTranslations?.bundle_of || `of ${requiredCount} products selected`)
        .replace('{{ count }}', requiredCount);
      bundleText.innerHTML = `
        ${window.bundleTranslations?.bundle_summary || 'Bundle'}:
        <span id="bundle-count">${count}</span>
        ${bundleOfText}
      `;
    }

    previewBox.innerHTML = '';

    let originalTotal = 0;
    Object.entries(selections).forEach(([type, v]) => {
      if (!v) return;
      originalTotal += v.price;

      const item = document.createElement('div');
      item.className = 'preview-item';
      item.innerHTML = `
        <img src="${v.image}" width="60" height="60" />
        <span>${v.product_title} / ${v.size || ''}</span>
        <button data-remove-type="${type}" class="remove-item-btn" aria-label="Remove item">
          <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3L1 3M5 6V10M8 6V10M11 3V12.5C11 12.6326 10.9476 12.7598 10.8538 12.8536C10.76 12.9473 10.6329 13 10.5 13H2.5C2.3674 13 2.2402 12.9473 2.1464 12.8536C2.0527 12.7598 2 12.6326 2 12.5V3M9 3V2C9 1.7348 8.8946 1.4804 8.7071 1.2929C8.5196 1.1054 8.2652 1 8 1H5C4.7348 1 4.4804 1.1054 4.2929 1.2929C4.1054 1.4804 4 1.7348 4 2V3" stroke="#E93636" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
      previewBox.appendChild(item);
    });

    previewBox.querySelectorAll('button[data-remove-type]').forEach((btn) => {
      btn.addEventListener('click', () => {
        selections[btn.dataset.removeType] = null;
        localStorage.setItem('bundleSelections', JSON.stringify(selections));
        updatePreview();
      });
    });

    const discountRate = window.bundleDiscountRate || 0.15;
    const discountedTotal = originalTotal * (1 - discountRate);

    const originalEl = document.getElementById('original-price');
    const discountedEl = document.getElementById('discounted-price');
    if (originalEl && discountedEl) {
      const sym = getCurrencySymbol(Shopify.currency?.active || 'EUR');
      originalEl.textContent = `${sym}${(originalTotal / 100).toFixed(2)}`;
      discountedEl.textContent = `${sym}${(discountedTotal / 100).toFixed(2)}`;
    }

    document.querySelectorAll('.bundle-missing-msg').forEach((m) => m.remove());

    if (count < requiredSelectionsCount && discountedEl) {
      const missing = requiredSelectionsCount - count;
      const notice = document.createElement('div');
      notice.className = 'bundle-missing-msg';
      notice.textContent = missing === 1
        ? (window.bundleTranslations?.one_missing || 'Just 1 more item to complete your bundle and unlock your discount!')
        : (window.bundleTranslations?.many_missing?.replace('{{ count }}', missing) || `Just ${missing} more items to complete your bundle and unlock your discount!`);
      discountedEl.insertAdjacentElement('afterend', notice);
    }

    addButton.disabled = count < requiredSelectionsCount;
    document.querySelector('.bundle-summary').classList.toggle('active', count > 0);
  }

  function renderGrid(groups, containerId, type) {
    const container = document.getElementById(containerId);
    container.innerHTML = '';

    groups.forEach((group) => {
      if (!group || !Array.isArray(group.variants) || !group.variants.length) return;

      const image = group.featured_image || '/placeholder.png';
      const color = group.color || 'Various';
      const hasAvailableVariants = group.variants.some((v) => v.available);

      const card = document.createElement('div');
      card.className = 'product-card';
      // PERF: loading=lazy + decoding=async; src gia' cappato a width 300.
      card.innerHTML = `
        <img src="${image}" width="100" height="100" loading="lazy" decoding="async" alt="${group.product_title} - ${color}" />
        ${!hasAvailableVariants ? '<div class="badge-out-of-stock">Out of Stock</div>' : ''}
      `;

      if (hasAvailableVariants) {
        card.addEventListener('click', function () {
          document.querySelectorAll(`#${containerId} .product-card`).forEach((c) => c.classList.remove('selected'));
          card.classList.add('selected');
          showProductDetail(group, type);
        });
      } else {
        card.style.opacity = '0.5';
        card.style.cursor = 'not-allowed';
      }

      container.appendChild(card);
    });
  }

  // ===================================================================
  // ADD TO CART
  // ===================================================================
  addButton.addEventListener('click', () => {
    const missingSelections = Object.entries(selections).filter(([, value]) => !value);
    if (missingSelections.length > 0) {
      document.querySelectorAll('.bundle-error-msg').forEach((el) => el.remove());
      const errorBox = document.createElement('div');
      errorBox.className = 'bundle-error-msg';
      errorBox.textContent = window.bundleTranslations?.missing_per_category
        || 'Please select one product per bundle category to proceed.';
      addButton.insertAdjacentElement('afterend', errorBox);
      return;
    }

    addButton.disabled = true;

    const items = Object.values(selections).map((v) => ({
      id: v.id,
      quantity: 1,
      properties: { _bundle: 'true' },
    }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((res) => {
        if (!res.ok) return res.text().then((text) => { throw new Error(text); });
        return res.json();
      })
      .then(() => {
        // La Discount Function "offer-kit3" applica il -15% da sola.
        localStorage.removeItem('bundleSelections');
        window.location.href = '/cart';
      })
      .catch(() => {
        addButton.disabled = false;
        alert("Errore durante l'aggiunta del bundle. Riprova.");
      });
  });

  function showProductDetail(group, type) {
    const panel = document.getElementById('product-detail-panel');
    const title = document.getElementById('detail-title');
    const link = document.getElementById('detail-view-link');
    const price = document.getElementById('detail-price');
    const stock = document.getElementById('stock-status');
    const options = document.getElementById('variant-options');
    const selectBtn = document.getElementById('confirm-selection-btn');

    panel.classList.remove('hidden');

    const toolbar = document.getElementById('bundle-toolbar');
    if (toolbar) {
      const y = toolbar.getBoundingClientRect().top + window.pageYOffset - 30;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    const galleryContainer = document.getElementById('detail-gallery');
    if (galleryContainer.flickityInstance) galleryContainer.flickityInstance.destroy();
    galleryContainer.innerHTML = '';
    galleryContainer.classList.add('gallery-flickity');

    const allImages = (group.gallery_images || []).filter((v, i, self) => v && self.indexOf(v) === i);
    allImages.forEach((src, index) => {
      const cell = document.createElement('div');
      cell.className = 'gallery-cell';
      // FIX (lug 2026): larghezza piena ESPLICITA sulla cella. Senza, tra
      // l'apertura del pannello e il caricamento delle foto w900 Flickity
      // impaginava celle shrink-to-fit e la gallery appariva per 1-3 secondi
      // come una striscia di miniature affiancate.
      cell.style.width = '100%';
      const alt = `${group.product_title} - ${index + 1}`;
      if (index === 0) {
        cell.innerHTML = `<img src="${src}" alt="${alt}" style="width:100%; height:auto;">`;
      } else {
        // Lazy vero di Flickity: le foto oltre la prima si scaricano solo
        // quando ci arrivi (lazyLoad: 1 = corrente + adiacente). Prima
        // l'apertura del pannello scaricava TUTTE le 6-10 foto w900 insieme.
        cell.innerHTML = `<img data-flickity-lazyload="${src}" alt="${alt}" style="width:100%; height:auto;">`;
      }
      galleryContainer.appendChild(cell);
    });

    galleryContainer.flickityInstance = new Flickity(galleryContainer, {
      cellAlign: 'center', contain: true, wrapAround: true,
      prevNextButtons: true, pageDots: true, lazyLoad: 1,
      imagesLoaded: true, draggable: true,
    });

    document.querySelectorAll('#detail-gallery .flickity-button.previous').forEach((btn) => {
      btn.innerHTML = '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 6H1.5" stroke="var(--color-body)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 1.5L1.5 6L6 10.5" stroke="var(--color-body)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    });
    document.querySelectorAll('#detail-gallery .flickity-button.next').forEach((btn) => {
      btn.innerHTML = '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 6H12.5" stroke="var(--color-body)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 1.5L12.5 6L8 10.5" stroke="var(--color-body)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    });

    title.textContent = group.color ? `${group.product_title} – ${group.color}` : group.product_title;

    link.href = `/products/${group.product_handle}?variant=${group.variants[0].id}`;

    const discountRate = window.bundleDiscountRate || 0.15;
    const discountedPrice = group.price * (1 - discountRate);
    const sym = getCurrencySymbol(Shopify.currency?.active || 'EUR');

    price.innerHTML = `
      <span class="bundle-price-final">${sym}${(discountedPrice / 100).toFixed(2)}</span>
      <span class="bundle-price-original">
        <em>${window.bundleTranslations?.regular_price || 'Regular price:'}</em> ${sym}${(group.price / 100).toFixed(2)}
      </span>
    `;

    const sized = group.variants.some((v) => v.size);

    options.innerHTML = '';
    let activeSize = null;

    if (sized) {
      let atLeastOneAvailable = false;

      group.variants.forEach((variant) => {
        const sizeValue = variant.size;
        const btn = document.createElement('button');
        btn.textContent = sizeValue;
        btn.style.minWidth = '40px';

        if (!variant.available) {
          btn.classList.add('variant-soldout');
          btn.title = 'Out of stock';
        } else {
          atLeastOneAvailable = true;
          btn.addEventListener('click', () => {
            options.querySelectorAll('button').forEach((b) => b.classList.remove('active'));
            btn.classList.add('active');
            activeSize = sizeValue;
            group.selected_variant = variant;

            const currentSizeValue = document.getElementById('current-size-value');
            if (currentSizeValue) currentSizeValue.textContent = sizeValue;

            stock.textContent = 'In Stock';
            stock.style.color = '#000';
            selectBtn.disabled = false;
            selectBtn.style.opacity = '1';
            selectBtn.style.cursor = 'pointer';
          });
        }

        options.appendChild(btn);
      });

      if (!atLeastOneAvailable) {
        stock.textContent = 'Out of Stock';
        stock.style.color = '#d00';
        selectBtn.disabled = true;
        selectBtn.style.opacity = '0.4';
        selectBtn.style.cursor = 'not-allowed';
      } else {
        stock.textContent = 'Stock Status';
        stock.style.color = '#000';
        selectBtn.disabled = true;
        selectBtn.style.opacity = '0.4';
        selectBtn.style.cursor = 'not-allowed';
      }
    } else {
      const note = document.createElement('div');
      note.textContent = 'No size selection required';
      options.appendChild(note);

      const single = group.variants.find((v) => v.available) || group.variants[0];
      group.selected_variant = single;

      if (!single.available) {
        stock.textContent = 'Out of Stock';
        stock.style.color = '#d00';
        selectBtn.disabled = true;
        selectBtn.style.opacity = '0.4';
        selectBtn.style.cursor = 'not-allowed';
      } else {
        stock.textContent = 'In Stock';
        stock.style.color = '#000';
        selectBtn.disabled = false;
        selectBtn.style.opacity = '1';
        selectBtn.style.cursor = 'pointer';
      }
    }

    selectBtn.onclick = function () {
      const variant = group.selected_variant;
      if (!variant || !variant.available) {
        alert('This variant is out of stock');
        return;
      }

      selections[type] = {
        id: variant.id,
        size: activeSize,
        title: `${group.product_title} / ${activeSize || ''}`,
        product_title: group.product_title,
        image: group.featured_image,
        price: variant.price,
      };

      localStorage.setItem('bundleSelections', JSON.stringify(selections));
      updatePreview();
      panel.classList.add('hidden');

      setTimeout(() => {
        document.querySelector('.bundle-builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const tabs = Array.from(document.querySelectorAll('.tab'));
        const activeTab = document.querySelector('.tab.active');
        if (!activeTab || tabs.length === 0) return;

        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) {
          tabs[currentIndex + 1].click();
        }
      }, 300);
    };
  }

  // Recupera il bundle salvato PRIMA di renderizzare
  const saved = localStorage.getItem('bundleSelections');
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      Object.entries(parsed).forEach(([type, item]) => {
        if (!item) return;
        selections[type] = {
          id: item.id,
          size: item.size,
          title: item.title,
          product_title: item.product_title,
          image: item.image,
          price: item.price,
        };
      });
    } catch {
      localStorage.removeItem('bundleSelections');
    }
  }

  renderProducts();
  rebindSliderTracks();
  updatePreview();
  bindCollectionTabs();

  setTimeout(() => {
    const tabsLeft = document.querySelector('.tabs-left');
    if (!tabsLeft) return;

    function aggiornaFade() {
      const scrollLeft = tabsLeft.scrollLeft;
      const maxScroll = tabsLeft.scrollWidth - tabsLeft.clientWidth;
      tabsLeft.style.setProperty('--fade-left-opacity', scrollLeft > 0 ? '1' : '0');
      tabsLeft.style.setProperty('--fade-right-opacity', scrollLeft < maxScroll - 1 ? '1' : '0');
    }

    aggiornaFade();
    tabsLeft.addEventListener('scroll', aggiornaFade);
    window.addEventListener('resize', aggiornaFade);
  }, 0);

  const firstTab = document.querySelector('.tabs-left .tab');
  if (firstTab) setTimeout(() => firstTab.click(), 0);
});
